import { createSlice } from '@reduxjs/toolkit';
import { showMessage } from '@Utils/RenderUtils';
import BackOfficeApi from './backOfficeInvoiceApi';

const initialState = {
  backOfficeInvoiceListAll: [],
  pageRequest: {
    direction: 'DESC',
    enabled: true,
    order: 'modifiedDate',
    name: '',
    page: 0,
  },
  loadingList: false,
  loading: false,
  confirming: false,
  backOfficeInvoiceList: {},
  backOfficeFilteredInvoiceList: {},
  errors: [],
  contractDetail: {},
  proformaInvoiceDetails: {},
};

export const contracts = createSlice({
  name: 'contractTemplate',
  initialState,
  reducers: {
    setLoading(state, { payload }) {
      state.loading = payload;
      state.loadingList = payload;
    },
    backOfficeInvoiceListAllFetchSuccess(state, { payload }) {
      state.backOfficeInvoiceListAll = payload;
    },
    invoiceListFetched(state, { payload }) {
      state.backOfficeInvoiceList = payload;
    },
    filteredInvoiceListFetched(state, { payload }) {
      state.backOfficeFilteredInvoiceList = payload;
    },
    invoiceListFetchedErrors(state, { payload }) {
      state.errors = payload;
    },
    filteredInvoiceListErrors(state, { payload }) {
      state.errors = payload;
    },
    setPageRequest(state, { payload }) {
      state.pageRequest = payload;
    },
    setContractDetail(state, { payload }) {
      state.contractDetail = payload;
    },

    setProformaInvoiceDetail(state, { payload }) {
      state.proformaInvoiceDetails = payload;
    },

    setConfirming(state, { payload }) {
      state.confirming = payload;
    },
  },
});

export default contracts.reducer;

export const {
  backOfficeInvoiceListAllFetchSuccess,
  setLoading,
  invoiceListFetched,
  invoiceListFetchedErrors,
  setPageRequest,
  setContractDetail,
  setProformaInvoiceDetail,
  setConfirming,
  filteredInvoiceListFetched,
  filteredInvoiceListErrors,
} = contracts.actions;

export const backOfficeInvoiceListAllFetch = (payload) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await BackOfficeApi.listAll(payload);
    dispatch(backOfficeInvoiceListAllFetchSuccess(response));
    dispatch(setPageRequest(payload?.pageRequest));

    dispatch(setLoading(false));
  } catch (e) {
    dispatch(setLoading(false));
  }
};

export const backOfficeInvoiceListFetch =
  (id, pageRequest) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await BackOfficeApi.list(id, pageRequest);
      dispatch(invoiceListFetched(response));
      dispatch(setPageRequest(pageRequest));

      dispatch(setLoading(false));
    } catch (err) {
      dispatch(invoiceListFetchedErrors(err));
      dispatch(setLoading(false));
    }
  };

export const backOfficeFilteredInvoiceListFetch =
  (pageRequest) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await BackOfficeApi.filteredList(pageRequest);
      dispatch(filteredInvoiceListFetched(response));
      dispatch(setPageRequest(pageRequest));

      dispatch(setLoading(false));
    } catch (err) {
      dispatch(filteredInvoiceListErrors(err));
      dispatch(setLoading(false));
    }
  };

export const backOfficeContractProductDetailFetch =
  (id) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await BackOfficeApi.getContractProduct(id);
      dispatch(setContractDetail(response));
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(setLoading(false));
    }
  };

export const backOfficeProformaInvoicesViewFetch = (id) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await BackOfficeApi.view(id);
    dispatch(setProformaInvoiceDetail(response));
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
  }
};

export const backOfficeProformaInvoiceConfirmFetch =
  (id, payload, cb) => async (dispatch) => {
    dispatch(setConfirming(true));
    try {
      const response = await BackOfficeApi.confirm(id, payload);
      dispatch(setConfirming(false));

      if (response) {
        cb();
        showMessage('fields updates are successfully confirmed', 'success');
      }
    } catch (err) {
      dispatch(setConfirming(false));
    }
  };
